/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */

window.config = {
  app_ui_name: 'Lightspeed Retail',
  debug_on: false,
};

window.isGriffin = function isGriffin() {
  if (window.StencilWebAPI.isStencil()) {
    // set new cookie
    window.docCookies.setItem('griffin', 'true', 0);
    return true;
  }

  window.docCookies.removeItem('griffin');

  return window.docCookies.hasItem('griffin');
};

window.handleiOSKeyboardAutoScroll = function handleiOSKeyboardAutoScroll() {
  // make sure that the view scrolls back to where it used to be before the keyboard popped up
  let scrollPositionX: TSFixMe;
  let scrollPositionY: TSFixMe;
  $(document).focusin(() => {
    if (scrollPositionX === undefined && scrollPositionY === undefined) {
      scrollPositionX = window.scrollX;
      scrollPositionY = window.scrollY;
    }
  });
  $(document).focusout(() =>
    setTimeout(() => {
      if (document.activeElement === document.body) {
        window.scroll(scrollPositionX, scrollPositionY);
        scrollPositionX = undefined;
        scrollPositionY = undefined;
      }
    }, 0)
  );
};

window.initGriffin = function initGriffin() {
  // StencilWebAPI is missing properties when initialized inside an iframe
  if (window.isGriffin() && window.self === window.top) {
    window.StencilWebAPI.init();
    window.StencilWebAPI.navigation = new window.Navigation();
    window.StencilWebAPI.printer = new window.Printer();
    window.StencilWebAPI.scanner = new window.Scanner();
    window.StencilWebAPI.cardReader.setProcessingDelegate(new window.CardReaderDelegate());
    window.StencilWebAPI.lock = new window.LockScreen();
    window.StencilWebAPI.shop = new window.StencilWebAPI.ShopBase();
    window.StencilWebAPI.signatureCapture = new window.StencilWebAPI.SignatureBase();
    window.StencilWebAPI.notifier = new window.GriffinNotifier();

    if (window.location.pathname === '/register.php') {
      window.StencilWebAPI.navigation.updateNavState();
    }

    window.handleiOSKeyboardAutoScroll();
  }
};

/**
 * Check for a mobile device using isGriffin helpers,  as well as
 * a userAgent string check.  Return whether or not this is a mobile device.
 *
 * returns {boolean} - Whether or not the page was loaded in a mobile device.
 */
window.isMobileDevice = function isMobileDevice() {
  /**
   * Apple changed the useragent for iPad in iOS13.
   * https://stackoverflow.com/a/58017456
   */
  const isIPad =
    RegExp(/Macintosh/i).test(navigator.userAgent) &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2;

  return (
    window.isGriffin() ||
    isIPad ||
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );
};

window.docCookies = {
  setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    // eslint-disable-next-line no-useless-escape
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    let sExpires = '';
    if (vEnd) {
      // eslint-disable-next-line default-case
      switch (vEnd.constructor) {
        case Number:
          sExpires =
            vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : `; max-age=${vEnd}`;
          break;
        case String:
          sExpires = `; expires=${vEnd}`;
          break;
        case Date:
          sExpires = `; expires=${(vEnd as any as Date).toUTCString()}`;
          break;
      }
    }
    document.cookie = `${escape(sKey)}=${escape(sValue)}${sExpires}${
      sDomain ? `; domain=${sDomain}` : ''
    }${sPath ? `; path=${sPath}` : ''}${bSecure ? '; secure' : ''}`;
    return true;
  },
  removeItem(sKey, sPath) {
    if (!sKey || !window.docCookies.hasItem(sKey)) {
      return false;
    }
    document.cookie = `${escape(sKey)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${
      sPath ? `; path=${sPath}` : ''
    }`;
    return true;
  },
  hasItem(sKey) {
    // eslint-disable-next-line no-useless-escape
    return new RegExp(`(?:^|;\\s*)${escape(sKey).replace(/[\-\.\+\*]/g, '\\$&')}\\s*\\=`).test(
      document.cookie
    );
  },
};

window.hex2bin = function hex2bin(hex) {
  const bytes = [];

  for (let i = 0; i < hex.length - 1; i += 2) bytes.push(parseInt(hex.substr(i, 2), 16));

  return String.fromCharCode(...bytes);
};

// Listener to prevent mouseWheel scroll from affecting numbers when target is a
// number input.  Always unbinds/rebinds to prevent multiple listeners from
// persisting through a series of ajax requests.
window.numberScrollInputFix = function numberScrollInputFix() {
  $('body').off('mousewheel');
  $('body').on('mousewheel', (event) => {
    if ($(event.target).is(':input[type=number]')) {
      event.preventDefault();
    }
  });
};

$(() => {
  window.initGriffin();
  window.numberScrollInputFix();
});
